// extracted by mini-css-extract-plugin
module.exports = {"disableControls":"_2ecb841f989ff3ac4e3d10b5463cb92d-less"};